import { render, staticRenderFns } from "./excelaktarim.vue?vue&type=template&id=6477f3d6"
import script from "./excelaktarim.vue?vue&type=script&lang=js"
export * from "./excelaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports